<template>
    <div>
        <image-component :infoType="'banner'" :infoKey="`fsBanner`"></image-component>

        <div class="content">
            <div class="amidan_tab" @click="changeTab('amidan')" :class="{'active': tab === 'amidan'}">아미단소개</div>
            <div class="amidan_tab" @click="changeTab('mentor')" :class="{'active': tab === 'mentor'}">멘토소개</div>
            <div class="amidan_tab" @click="changeTab('register')" :class="{'active': tab === 'register'}">가입신청</div>

            <image-component v-if="tab === 'amidan'" :infoType="'file'" :infoKey="`introduce`"></image-component>
            <member-list-component v-else-if="tab === 'mentor'" :memberType="`mentor`"></member-list-component>

            <div v-else-if="tab === 'register'">
                <regist-component></regist-component>
                <div class="ami_button">
                    <el-button class="ami_btn" @click="applyMember()" :disabled="loading">아빠미소멘토단 가입신청</el-button>
                    <div class="btn_amidan" v-if="hasErr">모두 입력해주세요</div>
                </div>
            </div>


            <terms-modal></terms-modal>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src


    import ImageComponent from "@/components/information/ImageComponent";
    import MemberListComponent from "@/components/member/MemberListComponent";
    import RegistComponent from "@/components/member/RegistComponent";
    import EventBus from "@/utils/event-bus";
    import TermsModal from "@/components/modal/TermsModal";

    export default {
        name: 'Amidan',
        mixins: [],
        components: {TermsModal, RegistComponent, MemberListComponent, ImageComponent},
        props: {},
        provide(){
            return{
                amidanSetData: this.setData,
                checkAllValidator:this.checkAllValidator
            }
        },
        data() {
            return {
                tab: 'amidan',
                loading: false,
                hasErr:false,
            }
        },
        beforeRouterEnter() {
        },
        created() {
            let checkTab = this.$route.query.hasOwnProperty('tab')
            if (checkTab) {
                this.changeTab(this.$route.query.tab)
            }
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            changeTab(tab) {
                this.$router.replace(this.$route.path);
                this.tab = '';
                this.$nextTick(() => {
                    this.tab = tab
                })
            },
            applyMember() {
                EventBus.$emit('runRegist')
            },
            setData(key, value) {
                this[key] = value;
            },
            checkAllValidator(check){
                this.hasErr = check
            }
        },
        watch: {},
    }
</script>
<style lang="scss">
    .amidan_tab {
        color: #9f9f9f;
        width: 366px;
        border-top: 1px solid;
        border-bottom: 1px solid;
        display: inline-block;
        text-align: center;
    }


</style>
